(function () {
  var form = document.querySelector('[data-fc-form]');
  if (!form) return;

  var souSelect   = form.querySelector('select[name="contact[sou]"]');
  var empresaWrap = form.querySelector('[data-fc-empresa]');
  var empresaInput = empresaWrap ? empresaWrap.querySelector('input') : null;
  var empresaLabel = empresaWrap ? empresaWrap.querySelector('label') : null;

  var requireEmpresa = [
    'Arquiteto / Designer de Interiores',
    'Construtora / Empresa',
    'Revendedor / Parceiro'
  ];

  function toggleEmpresa() {
    if (!souSelect || !empresaInput) return;
    var needs = requireEmpresa.indexOf(souSelect.value) !== -1;
    empresaInput.required = needs;
    if (empresaLabel) {
      empresaLabel.textContent = needs ? 'Empresa *' : 'Empresa (opcional)';
    }
    if (empresaWrap) {
      empresaWrap.setAttribute('data-required', needs ? 'true' : 'false');
    }
  }

  if (souSelect) {
    souSelect.addEventListener('change', toggleEmpresa);
    toggleEmpresa();
  }

  /* Pre-fill assunto via ?assunto=visita */
  var params = new URLSearchParams(window.location.search);
  var assuntoParam = params.get('assunto');
  if (assuntoParam === 'visita') {
    var assuntoSelect = form.querySelector('select[name="contact[assunto]"]');
    if (assuntoSelect) {
      assuntoSelect.value = 'Visita à fábrica';
    }
  }
})();
